import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';

class StatisticsWidgetCharts{
	static init($context = null){
		var inputSelector = "[data-chart-container]";
		let $containers = $context ? $context.find(inputSelector) : $(inputSelector);


		$containers.each(function (index, container) {
			if($(container).data('chart_instance')) return;
			$(container).data('chart_instance', new StatisticsWidgetCharts(container))
		});
	}



	constructor(wrap) {
		this.wrap = wrap
		this.$wrap = $(wrap)

		this.dataset = this.$wrap.data('dataset')

		var root = this.root = am5.Root.new(wrap, {});
		var chart = this.chart = root.container.children.push(am5xy.XYChart.new(root, {
			panX: false,
			panY: false,
			wheelX: "panX",
			wheelY: "zoomX",
			layout: root.verticalLayout
		}));


		// var legend = chart.children.push(
		// 	am5.Legend.new(root, {
		// 		centerX: am5.p50,
		// 		x: am5.p50
		// 	})
		// );

		// // Retrieve the translation from data attribute
		const zoomOutText = this.$wrap.data("zoom-out") || "Atitolinti";
		chart.zoomOutButton.set("tooltipText", zoomOutText);

		const zoomOutTooltip = am5.Tooltip.new(root, {});

		zoomOutTooltip.get("background").setAll({
			fill: am5.color(0x86AAA3),
			fillOpacity: 0.8
		});

		chart.zoomOutButton.set("tooltip", zoomOutTooltip);

		var dataGrouped = {}

		this.dataset.forEach(function (dataset, index) {
			dataset.obs.forEach(function (obs) {
				if(!dataGrouped[obs.category]){
					dataGrouped[obs.category] = {
						category: obs.category
					}
				}
				dataGrouped[obs.category]["value_" + index] = parseFloat(obs.value)
			})
		})

		var data = Object.values(dataGrouped)


	// Create axes
	// https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
		var xRenderer = am5xy.AxisRendererX.new(root, {
			cellStartLocation: 0.1,
			cellEndLocation: 0.9
		})

		var xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
			categoryField: "category",
			renderer: xRenderer,
			tooltip: am5.Tooltip.new(root, {})
		}));

		xRenderer.grid.template.setAll({
			location: 1
		})

		xAxis.data.setAll(data);

		var yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
			renderer: am5xy.AxisRendererY.new(root, {
				strokeOpacity: 0.1
			})
		}));

		function makeSeries(name, fieldName) {
			var series = chart.series.push(am5xy.ColumnSeries.new(root, {
				name: name,
				xAxis: xAxis,
				yAxis: yAxis,
				valueYField: fieldName,
				categoryXField: "category"
			}));

			series.columns.template.setAll({
				tooltipText: "{name}, {categoryX}:{valueY}",
				width: am5.percent(90),
				tooltipY: 0,
				strokeOpacity: 0
			});

			series.data.setAll(data);

			// Make stuff animate on load
			// https://www.amcharts.com/docs/v5/concepts/animations/
			series.appear();

			series.set("fill", am5.color("#86aaa3"));


			var xRenderer = xAxis.get("renderer");
			xRenderer.labels.template.setAll({
				visible : false,
			});

			var yRenderer = yAxis.get("renderer");
			yRenderer.labels.template.setAll({
				visible : false,
			});

			series.columns.template.setAll({
				tooltipText: "{name}, {categoryX}:{valueY}",
				width: am5.p100,
				tooltipY: 0,
				cornerRadiusTL: 5,
				cornerRadiusTR: 5,
				cornerRadiusBL: 5,
				cornerRadiusBR: 5
			});


			// legend.data.push(series);
		}


		this.dataset.forEach(function (dataset, index) {
			makeSeries(dataset.title, "value_" + index);
		})
	}
}


StatisticsWidgetCharts.$ = $;
if (typeof module === "object" && typeof module.exports === "object"){
	StatisticsWidgetCharts.init()
	//node modules support
	module.exports = StatisticsWidgetCharts;
}else{
	$(function(){
		StatisticsWidgetCharts.init()
	});
}